<template>

  <div class="display-container"
       :style="`min-height: ${getHeight}; min-width: ${minWidth}; ${getWidth ? 'width: ' + getWidth : ''}; `"
       :class="[`${getEmptyBgColor} ${getFullHeight} relative-position`, !noOverflowHidden ? 'display-container' : '' ]"
       style="outline: 0 solid red"
       v-if="isActiveComponent">

    <slot name="header" :component="getThis" />

    <div :class="`${getFullHeight} ${displayData.length < 1 ? 'bg-grey-2' : ''}`" :style="`${getBodyMinHeight}`">
      <q-slide-transition>
        <q-carousel v-if="displayData.length > 0"
                    v-model="slide"
                    :autoplay="getInterval"
                    :height="getHeight"

                    :transition-prev="getEffect.prev"
                    :transition-next="getEffect.next"

                    infinite
                    animated
                    :control-color="getControlColor"

                    :arrows="getArrows"
                    :navigation="getNavigation"
                    :swipeable="getSwipeable"

                    :class="`${getFullHeight} ${getAlign} ${getStyleOverflowVisible} ${bodyClasses}`"

        >
          <q-carousel-slide :name="index+1" v-for="(dp, index) in displayData" :key="index" :class="`no-padding ${getAlign} ${getFullHeight} ${slideDisplay}`" class="relative-position">

            <!-- custom link 사용 (자동으로 링크 사용하지 않음) -->
            <div v-if="noAutoLink" class="full-width">
              <div v-if="dp.dp_type === 'ORIGINAL' || dp.dp_type === 'THUMB'" @click="clickedAD(dp)">
                <slot :row="dp" :component="getThis"></slot>
              </div>
              <div v-else-if="dp.dp_type === 'BANNER'" class="full-width" @click="clickedAD(dp)">
                <img :src="getImage(dp)" :style="getImgSizeByStyle(dp)" class="full-height" />
              </div>
              <div v-else-if="dp.dp_type === 'HTML'"
                   v-html="dp.dp_html"
                   class="full-width full-height"
                   :style="`min-height: ${minHeight}`"
                   @click="clickedAD(dp)">
              </div>
            </div>
            <!-- vue route link (vue route 사용) -->
            <div v-else-if="isUseRouterLink(dp)" class="full-width">
              <router-link :to="getLinkUrl(dp)" :target="getLinkTarget(dp)" :class="{'full-width': dp.dp_type !== 'BANNER'}">
                <div v-if="dp.dp_type === 'ORIGINAL' || dp.dp_type === 'THUMB'" @click="clickedAD(dp)">
                  <slot :row="dp" :component="getThis"></slot>
                </div>
                <div v-else-if="dp.dp_type === 'BANNER'" @click="clickedAD(dp)">
                  <img :src="getImage(dp)" :style="getImgSizeByStyle(dp)" />
                </div>
                <div v-else-if="dp.dp_type === 'HTML'"
                     v-html="dp.dp_html"
                     class="full-width full-height"
                     :style="`min-height: ${minHeight}`"
                     @click="clickedAD(dp)">
                </div>
              </router-link>
            </div>
            <!-- full url link (전체 새로고침) -->
            <a v-else :href="getLinkUrlATag(dp)" :target="getLinkTarget(dp)" :class="{'full-width': dp.dp_type !== 'BANNER'}">
              <div v-if="dp.dp_type === 'ORIGINAL' || dp.dp_type === 'THUMB'" @click="clickedAD(dp)">
                <slot :row="dp" :component="getThis"></slot>
              </div>
              <div v-else-if="dp.dp_type === 'BANNER'" @click="clickedAD(dp)">
                <img :src="getImage(dp)" :style="getImgSizeByStyle(dp)" class="full-height" />
              </div>
              <div v-else-if="dp.dp_type === 'HTML'"
                   v-html="dp.dp_html"
                   class="full-width full-height"
                   :style="`min-height: ${minHeight}`"
                   @click="clickedAD(dp)">
              </div>
            </a>

            <div v-if="(index+1) === slide" style="height: 0">
              <img :src="getExposedADUrl(dp)" width="0" height="0" style="max-width: 0; max-height: 0" v-show="1===0">
            </div>

          </q-carousel-slide>
        </q-carousel>
      </q-slide-transition>
    </div>

    <slot name="footer" :component="getThis" />

  </div>

</template>

<script>
  import Vue from 'vue'
  import { QCarousel, QCarouselControl, QCarouselSlide, QSlideTransition } from 'quasar'
  import CommonComputed from 'src/_mixins/CommonComputed'
  import CommonMethods from 'src/_mixins/CommonMethods'
  import { mapGetters } from 'vuex'
  export default {
    components: {
      QCarousel,
      QCarouselControl,
      QCarouselSlide,
      QSlideTransition,
    },
    props: {
      section: {
        default: 0
      },
      width: {
        default: ''
      },
      height: {
        default: ''
      },
      align: {
        default: 'center'
      },
      minWidth: {
        default: ''
      },
      minHeight: {
        default: ''
      },
      slideDisplay: {
        default: 'flex_center'
      },
      bodyMinHeight: {
        default: ''
      },
      bodyClasses: {
        default: ''
      },
      emptyBgColor: {
        default: ''
      },
      noAutoLink: {
        default: false,
        type: Boolean
      },
      useInteractiveImage: {
        default: false,
        type: Boolean
      },
      noOverflowHidden: {
        default: false,
        type: Boolean
      },
      duration: 0,
      arrows: {
        default: false,
        type: Boolean
      },
      navigation: {
        default: false,
        type: Boolean
      },
      swipeable: {
        default: false,
        type: Boolean
      },
      control_color: {
        default: 'secondary'
      },
      vertical: {
        default: false,
        type: Boolean
      },
      autoplay: {
        default: true,
        type: Boolean
      },
      advertising: {
        default: false,
        type: Boolean
      },
      visible: {
        default: false,
        type: Boolean
      },
    },
    data () {
      return {
        displayData: [],
        displayCate: {},
        currentDisplayRow: null,
        slide: 0,
        effect: {
          show: 'fade',
          hide: 'fade',
          prev: 'fade',
          next: 'fade'
        },
        eventExposedAD: false,
        isActivated: false
      }
    },
    watch: {
      '$route': 'init',
      'isUpdatedDisplayData' (flag) {
        if (flag && this.isActiveComponent) {
          // if (!this.getInterval)
          if (this.isExistDisplayPage(this.getRouteName)) {
            setTimeout(() => this.getCurrentDisplayData())
          } else {
            setTimeout(() => this.getCurrentDisplayData(), 300)
          }
        }
      }
    },
    beforeMount () {
      // if ([2,4,5,6,7,8,9].includes(this.section)) console.log('mounted', this.section)
      this.$nextTick(() => {
        this.init()
        this.triggerExposedADUrl()
      })
    },
    activated () {
      // if ([2,4,5,6,7,8,9].includes(this.section)) console.log('activated', this.section)
      this.isActivated = true
      this.triggerExposedADUrl()
    },
    deactivated () {
      this.isActivated = false
    },
    computed: {
      ...CommonComputed,
      ...mapGetters([
        'isUpdatedDisplayData',
        'isExistDisplayPage'
      ]),
      getAccess () {
        return 'pc'
      },
      getAdViewUrl () {
        return 'https://teralog.techhub.co.kr/imp?la_gc=TR8703006127&la_src=ib&la_cnfg=' // 테라 실계정 PC
        // return 'https://teralog.techhub.co.kr/imp?la_gc=TR8703005279&la_src=ib&la_cnfg=' // 테라 테스트계정 PC
      },
      isActiveComponent () {
        // console.log(this.section, this.getRootComponentName)
        const rtn =
        (
          this.getRootComponentName === 'DefaultLayout'
          || this.getRootComponentName === 'SubPageLayout'
          || this.getRootComponentName === 'PageLayout'
          || this.getRootComponentName === 'QDialog'
          || this.getRootComponentName === this.getRouteName
        )
        return rtn
      },
      getThis () {
        return this
      },
      getAlign () {
        return this.align === 'left' || this.align === 'right' ? 'text-'+this.align
          : this.align === 'top' || this.align === 'bottom' ? 'absolute-'+this.align
          : 'text-center'
      },
      getFullHeight () {
        return this.align !== 'top' && this.align !== 'bottom' ? 'full-height' : ''
      },
      getDuration () {
        // console.log(this.displayCate)
        return this.displayCate.duration ? this.displayCate.duration : this.duration
      },
      getEmptyBgColor () {
        // console.log(this.emptyBgColor)
        return this.displayData.length < 1
          ? this.emptyBgColor ? this.emptyBgColor : 'bg-grey-2'
          : ''
      },
      getCurrentDisplayDataCnt () {
        return this.displayData.length
      },
      getCurrentDisplayRow () {
        return this.currentDisplayRow && Object.keys(this.currentDisplayRow).length > 0 ? this.currentDisplayRow : null
      },
      getExclusionCodeAdChannel () {
        return this.getAccess === 'mobile' ? 'P' : 'M'
      },
      getControlColor () {
        return this.displayCate.control_color ? this.displayCate.control_color : this.control_color
      },
      getArrows () {
        return this.displayCate.arrows ? this.displayCate.arrows : this.arrows
      },
      getNavigation () {
        return this.displayCate.navigation ? this.displayCate.navigation : this.navigation
      },
      getSwipeable () {
        return this.displayCate.swipeable ? this.displayCate.swipeable : this.swipeable
      },
      getEffect () {
        let effect = this.cloneData(this.effect)
        if (this.displayCate.effect) {
          if (this.displayCate.effect.json) {
            if (this.displayCate.effect.json.show) effect.show = this.displayCate.effect.json.show
            if (this.displayCate.effect.json.hide) effect.hide = this.displayCate.effect.json.hide
          } else {
            this.displayCate.effect.json = {}
          }
          effect.prev = this.displayCate.effect.json.prev
          effect.next = this.displayCate.effect.json.next
        }
        // console.log(effect)
        return effect
      },
      getStyleOverflowVisible () {
        // console.log(this.getEffect.prev)
        return this.getEffect.prev === 'rotate' || this.noOverflowHidden ? 'overflow_visible' : ''
      },
      getSlideIndex () {
        // console.log(this.displayData.length)
        return this.slide = this.getRandomIndex ? this.getRandomIndex : 1
      },
      getWidth () {
        return this.displayCate && this.displayCate.width ? this.displayCate.width : this.width ? this.width : ''
      },
      getHeight () {
        return this.displayCate && this.displayCate.height ? this.displayCate.height : this.height ? this.height : ''
      },
      getBodyMinHeight () {
        return this.bodyMinHeight ? 'min-height: '+this.bodyMinHeight : ''
      },
      getRandomIndex () {
        return Math.floor(Math.random() * (this.displayData.length - 1 + 1)) + 1
      },
      getInterval () {
        return this.displayCate && this.displayCate.interval ? Math.abs(this.displayCate.interval) : false
      },
      getSectionTitle () {
        return this.displayCate.title ? this.displayCate.title : ''
      },
      getSectionSubTitle () {
        return this.displayCate.subtitle ? this.displayCate.subtitle : ''
      },
      getSectionInitial () {
        return this.displayCate.initial ? this.displayCate.initial : ''
      },
      getSectionInitialFirstCharacter () {
        return this.getSectionInitial.substr(0,1)
      },
      getInteractivePostfix () {
        return this.useInteractiveImage ? '_interactive' : ''
      },
      getIsActivated () {
        return this.isActivated
      }
    },
    methods: {
      ...CommonMethods,
      init () {
        if (!this.getInterval) {
          this.getDisplayCate()
          this.getCurrentDisplayData()
        }
      },
      getDisplayCate () {
        const cnt =  this.$store.getters.getDisplayCateDataCnt
        if (cnt) {
          this.getCurrentDisplayCate()
        } else {
          this.getDisplayCateDataFormDB()
        }
      },
      getDisplayCateDataFormDB () {
        if (this.section > 0) {
          const action = '/display_cates'
          if (!this.$store.getters.isExistListOfCalledAPI(action)) {
            this.$store.dispatch('putListOfCalledAPI', action).then(() => {
              this.$axios.get(action).then((static_rs) => {
                this.$axios.get('/post_cates/special').then((dynamic_rs) => {
                  this.$store.dispatch('setDisplayCateData', static_rs.data.value.concat(dynamic_rs.data)).then(() => {
                    this.getCurrentDisplayCate()
                  })
                })
              }).catch(() => {})
            })
          } else {
            setTimeout(function() {
              this.getDisplayCate()
            }.bind(this), 100)
          }
        }
      },
      getCurrentDisplayCate () {
        const data = this.$store.getters.getDisplayCateData
        this.displayCate = this.getDisplayCateFlat(data).find(row => row.idx === this.section)
        // console.log('init', this.displayCate.name)
      },
      getCurrentDisplayData () {
        if (this.getCurrentDisplayDataCnt < 1) {
          const data = this.$store.getters.getDisplayData
          this.displayData = data.reduce((acc, cur) => {
            if (cur.section && cur.section.idx === this.section) acc.push(cur)
            return acc
          }, [])
          this.slide = this.getSlideIndex
          if (this.displayData.length > 0 && this.displayData[this.slide - 1]) this.currentDisplayRow = this.cloneData(this.displayData[this.slide - 1])
        }
      },
      getDisplayCateFlat (obj) {
        return obj.reduce((acc, cur) => {
          acc.push(cur)
          cur.sections.map(cur2 => {
            acc.push(cur2)
            if (cur2.sections) cur2.sections.map(cur3 => {
              acc.push(cur3)
              // if (cur3.sections) cur2.sections.map(cur4 => {
              //   acc.push(cur4)
              //   if (cur4.sections) cur2.sections.map(cur5 => {
              //     acc.push(cur5)
              //   })
              // })
            })
          })
          return acc
        }, [])
      },
      isDpTypeTemplate (dp) {
        return dp.dp_type === 'ORIGINAL' || dp.dp_type === 'THUMB'
      },
      isDpTypeBanner (dp) {
        return dp.dp_type === 'BANNER'
      },
      getImage (dp, gb='_top') {
        return dp.dp_type === 'ORIGINAL'
          ? this.getImageSrcIfExist(dp, gb)
          : this.getFileExist(dp[this.getAccess+'_img' + this.getInteractivePostfix])
      },
      getImageInteractive (dp) {
        return this.getFileExist(dp[this.getAccess+'_img_interactive'])
      },
      getImageSrcIfExist (dp, gb='_top') {
        return (dp.model === 'posts' && dp.model_data) ? dp.model_data[`post${gb}_img`].url : ''
      },
      getImgSizeByStyle (dp) {
        const size = dp[this.getAccess+'_img_size']
        const width = size.width ? size.width+'px' : 'auto'
        const height = size.height ? size.height+'px' : this.getHeight ? this.getHeight : '100%'
        return `width: ${width}; height: ${height}`
      },
      getName (dp) {
        return (dp.model === 'posts' && dp.model_data) ? dp.model_data.title : ''
      },
      getTitle (dp) {
        // console.log(dp)
        return dp && dp.dp_title && dp.dp_title !== '' ? dp.dp_title
          : (dp && dp.model === 'posts' && dp.model_data) ? dp.model_data.title
          : ''
      },
      getFee (dp) {
        return dp && dp.dp_fee && dp.dp_fee !== '' ? dp.dp_fee
          : '<span>'+dp.model_data.annual_fee_basic.replace(/\[/g,'').replace(/\//g, '</span> / <span>').replace(/\]/g,'') + '</span>'
      },
      getText1 (dp) {
        return dp.dp_text1 ? dp.dp_text1 : (dp && dp.model === 'posts' && dp.model_data) ? dp.model_data.contents : ''
      },
      getText2 (dp) {
        return dp.dp_text2
      },
      getCate (dp) {
        return (dp.model === 'posts' && dp.model_data) ? dp.model_data.post_cate.name : ''
      },
      getCateIntial (dp) {
        return (dp.model === 'posts' && dp.model_data) ? dp.model_data.post_cate.initial : ''
      },
      getCateColor (dp) {
        return (dp.model === 'posts' && dp.model_data) ? dp.model_data.post_cate.color : ''
      },
      getCateEng (dp) {
        return (dp.model === 'posts' && dp.model_data) ? dp.model_data.post_cate.name_eng : ''
      },
      getWriter (dp) {
        return (dp.model === 'posts' && dp.model_data) ? dp.model_data.writer.nick : this.getAppName
      },
      getWriterProfImage (dp) {
        return (dp.model === 'posts' && dp.model_data && dp.model_data.writer.prof_img) ? dp.model_data.writer.prof_img.url : ''
      },
      getRegDate (dp) {
        return dp.model === 'posts' && dp.model_data && dp.model_data.reg_dt ? dp.model_data.reg_dt : ''
      },
      getDpRegDate (dp) {
        return dp.reg_dt ? dp.reg_dt : ''
      },
      getTags (dp) {
        return dp.model === 'posts' && dp.model_data && dp.model_data.tags ? dp.tags : []
      },
      getContents (dp) {
        return this.getTextCroped(dp.contents)
      },
      attachaccess (val) {
        return val + '_' + this.getAccess
      },
      getLinkUrl (dp) {
        // if (this.noAutoLink) return ''
        // alert(dp.model)
        const url = dp[this.attachaccess('link_url')]
          ? dp[this.attachaccess('link_url')]
          : (dp.model === 'posts' && dp.model_data) ? '/article/'+dp.model_data.idx
          : ''
        return url
      },
      getLinkUrlATag (dp) {
        let url = this.getLinkUrl(dp)
        return url ? url : 'javascript:'
      },
      getLinkTarget (dp) {
        return dp[this.attachaccess('link_target')]
      },
      isUseRouterLink (dp) {
        // console.log(this.getLinkUrl(dp).substr(0, 4))
        const url = this.getLinkUrl(dp) ? this.getLinkUrl(dp).substr(0, 4) : ''
        const rtn = !(url === 'http')
        return rtn
      },
      getExposedADUrl (dp) { // TERA 광고코드 노출 스크립트 비동기 호출   // TODO 모바일단에서 스크립트 변경해야함
        if (dp.section.idx === 2) console.log(this.getAccess, dp[this.attachaccess('ad_code')])
        return dp.is_advertising && dp[this.attachaccess('ad_code')] && dp.ad_channel !== this.getExclusionCodeAdChannel
          ? this.getAdViewUrl + dp[this.attachaccess('ad_code')]
          : ''
      },
      clickedAD (dp) {// TERA 광고코드 클릭 스크립트 비동기 호출   // TODO 모바일단에서 스크립트 변경해야함
        if (dp.is_advertising && dp[this.attachaccess('ad_code')] && dp.ad_channel !== this.getExclusionCodeAdChannel) {
          _LA.BCT(dp[this.attachaccess('ad_code')])
          console.log('ad click')
        }
      },
      triggerExposedADUrl () {  // 롤링되지 않는 섹션의 TERA노출 이벤트를 강제 트리거 시킴 (페이지 이동시 노출 이벤트 발생)
        // console.log(this.getRootComponentName, this.getParentComponentName, this.getCurrentComponentName, this)
        // if (this.getCurrentDisplayRow) console.log(this.getIsActivated, this.getCurrentDisplayRow.section.pathName)
        if (this.getCurrentDisplayRow && (this.getCurrentDisplayRow.section.data[0].idx === 1 || this.getIsActivated) && this.getCurrentDisplayDataCnt === 1 ) {
          // console.log(this.getCurrentDisplayRow.did, this.getCurrentDisplayRow.section.pathName, this.getCurrentDisplayDataCnt)
          const rtn = this.getExposedADUrl(this.getCurrentDisplayRow)
          if (rtn) {
            const img = (new Image(0,0)).src=rtn
            // console.log('trigger tera exposed event.')
            // console.log(`did: ${this.getCurrentDisplayRow.did}, section: ${this.getCurrentDisplayRow.section.pathName.replace(/\ /g, '')}`)
          }
        }
      }
    }
  }
</script>

<style scoped>
  a {
    cursor: pointer;
    display: inline-block;
    overflow: hidden;
    position: relative;
    z-index: 1;
  }
  /deep/ a .img {
    border-radius: 8px;
    overflow: hidden;
  }

  /deep/ .el-carousel__arrow {
    display: none;
  }
  /deep/ .overflow_visible {
    overflow: visible !important;
    overflow-x: visible !important;
    overflow-y: visible !important;
  }

  .display-container {
    -ms-overflow-style: none;
  }
  .display-container::-webkit-scrollbar {
      display:none;
  }

  /deep/  .scroll {
    overflow: hidden !important;
  }

</style>
